import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  CartItemCreateRequestList,
  QuotationCurrenciesRequestModel,
  QuotationRequestModel,
  RemittanceStep01Model,
} from "app/modules/card/models/card.model";
import { CardService } from "app/modules/card/services/card.service";
import { QuotationCurrencyItem } from "app/modules/dashboard/models/quotation.models";
import { InsuranceService } from "app/modules/insurance/services/insurance.service";
import { OrderService } from "app/modules/order/services/order.service";
import { UpdateProfileModel } from "app/modules/update-profile/models/update-profile.model";
import { UpdateProfileService } from "app/modules/update-profile/services/update-profile.service";
import { Constants } from "app/shared/constant/constants";
import { ConstantsKey } from "app/shared/constant/constants-keys";
import { NewDashboardPurposeList } from "app/shared/constant/new-dashboard-menu";
import {
  ReqGetCurrencyMaster,
  SingleRateResItem,
} from "app/shared/models/shared-models";
import { MasterDataService } from "app/shared/services/master-data.service";
import { CryptoUtils } from "app/shared/utility/crypto.utils";
import { DateUtils } from "app/shared/utility/date-utils";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime, map } from "rxjs/operators";

@Component({
  selector: "currency-notes-landing",
  templateUrl: "./currency-notes-landing.component.html",
  styleUrls: ["./currency-notes-landing.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CurrencyNotesLandingComponent implements OnInit, OnDestroy {
  public showLoader: boolean = false;
  public showLoaderForCardDetails: boolean = false;

  public consumerData: any;
  public showBuyCard: boolean = false;
  public cashLimitError: boolean = false;
  public cashLimitErrorMsg: string;

  public quotationCurrencyItem: QuotationCurrencyItem =
    new QuotationCurrencyItem();
  public reqGetCurrencyMaster: ReqGetCurrencyMaster =
    new ReqGetCurrencyMaster();

  public panName: string;
  public currencyItems: any;
  public vcipStatusDetails: any;

  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public rateCalculatorResponse: any;
  public vcipMessage: any;
  public currencyAmount;
  public currencySelectedObj: any;
  public vcipAccepted: any;
  public currencySelected: any;
  public quotationResponse: any;
  public quotationSnapshotId: any;
  public tcsPaymentSource = "OWN";
  public consumerPanSelf: string;
  public consumerDetail: any;
   currencyText: string = "You Get";
  inrText: string = "You Pay";
  inrAmount: string = "";

  public quotationCurrencyResponsesList = [];
  public cartCurrenciesList = new Array<QuotationCurrenciesRequestModel>();
  @ViewChild("errorModal") errorModal: TemplateRef<any>;
  @ViewChild("currenyBuyModal") currenyBuyModal: TemplateRef<any>;

  public showButtonOnVCIP: boolean = false;
  public newPinShow: boolean = false;
  public confirmPinShow: boolean = false;
  public proceedWithoutVCIPCompletion = "false";
  public showPricing: boolean = false;
  public showCommentInput: boolean = false;
  public showBuyForexForm: boolean = false;
  public activeBuyCurrenyNotes: boolean = false;
  public activeSellCurrencyNotes: boolean = false;

  public singleRateResItem: SingleRateResItem = new SingleRateResItem();
  public remittanceStep01: RemittanceStep01Model = new RemittanceStep01Model();
  public quotationRequest = new QuotationRequestModel();
  public quotationRequestModel: QuotationRequestModel;
  public isVcipComplete: boolean = false;
  public cardLinkedAlready: boolean = false;
  public isOrderWithoutVcipComplete: boolean = false;
  public isPANAvailable: boolean = false;

  @ViewChild("vcipCompleteOrNotModal") vcipCompleteOrNotModal: TemplateRef<any>;
  @ViewChild("vcipModalNewUser") vcipModalNewUser: TemplateRef<any>;
  @ViewChild("PANDetailModal") PANDetailModal: TemplateRef<any>;
  @ViewChild("AmountLimitModal") AmountLimitModal: TemplateRef<any>;
  @ViewChild("currencyAmountInput", { read: ElementRef })
  currencyAmountInput: ElementRef;

  public modalReference: any;
  public updateProfileModel = new UpdateProfileModel();
  public ssoResponseData: any;
  public orderListItems: any;
  public paxId: any;
  vkycTimingText: string;
  public ngbDatepicker: NgbDateStruct;
  showErrorModal: boolean;
  dobMaxDate: any;
  isPANCBChecked: boolean = false;
  panVerificationErrMsg: string;
  isVCIPNow: boolean = false;
  currencyInputsubscription: Subscription;
  buyCurrencyImg:string = "Buy-Currency-Notes";
  sellCurrencyImg:string = "Sell-Currency-Notes";
  public branchAddressList = [];
  public currencyBranchId = "b-wsfl15";
  public selectedBranch: any;


  constructor(
    private cardService: CardService,
    private masterDataService: MasterDataService,
    private router: Router,
    public updateProfileService: UpdateProfileService,
    public toast: ToastrService,
    private orderService: OrderService,
    public modalService: NgbModal
  ) {
    this.currencySelected = "USD";
  }

  ngOnInit() {
    if (localStorage.getItem(ConstantsKey.SSO_RESP)) {
      this.ssoResponseData = JSON.parse(
        localStorage.getItem(ConstantsKey.SSO_RESP)
      );
      this.currencyAmount = this.ssoResponseData["requiredCurrencyCodeAmount"];
      this.currencySelected = this.ssoResponseData["requiredCurrencyCode"];
      console.log("SSO resp");
      // this.getRateRange();
    }
    //this.getProfileDetails();
    this.getLocalData();
    this.showBuyCurrencyNotes('BUY');
    //this.getRateRange();
    this.getCurrencies();
    this.getNearByBranchLocation();    
    this.callThreeWayCalculator();
    //this.convertAmount();
  }

  ngAfterViewInit(): void {
    this.currencyInputsubscription = fromEvent(
      this.currencyAmountInput.nativeElement,
      "keyup"
    )
      .pipe(
        map((event) => this.currencyAmountInput.nativeElement.value),
        debounceTime(1000)
      )
      .subscribe((val) => {
       // this.convertAmount();
              this.callThreeWayCalculator();

      });
  }

  // ngAfterViewInit(): void {
  //   var product = localStorage.getItem(ConstantsKey.PRODUCT);
  //   if (product == 'BUY-CASH') {
  //     this.openModalCurrencyBuy();
  //   }
  //   localStorage.removeItem(ConstantsKey.PRODUCT);

  //  }
  async getProfileDetails() {
    this.showLoader = true;
    var resp = await this.updateProfileService.getProfileListAll().toPromise();

    this.showLoader = false;
    this.consumerDetail = resp.body;
    this.paxId = this.consumerDetail.paxResponse.id;
    this.isVcipComplete = this.consumerDetail?.vcipKyc;
    if (this.consumerDetail?.paxResponse?.consumer?.vcipSkipAllowed) {
      this.isVcipComplete = true;
    } else if (
      this.consumerDetail?.paxResponse?.consumer?.offlineonboarding == "1"
    ) {
      this.isVcipComplete = true;
    }
    if (
      this.consumerDetail?.paxResponse != null &&
      this.consumerDetail?.paxResponse?.pan
    ) {
      this.isPANAvailable = true;
    }
    if (!this.isVcipComplete) {
      this.getVCIPStatus();
    }
    console.log("this.consumerDetail >>", this.consumerDetail);

    return true;
  }
  getVCIPStatus() {
    this.showLoader = true;
    this.updateProfileService.getVCIPStaus().subscribe(
      (resp) => {
        this.showLoader = false;
        this.vcipStatusDetails = resp.body;
        if (this.vcipStatusDetails.vcipStatus == "ACCEPTED") {
          this.isVcipComplete = true;
        }
        // else {
        //   this.getOrderList();
        // }
        localStorage.setItem(
          ConstantsKey.IS_VCIP_COMPLETE,
          this.isVcipComplete.toString()
        );
      },
      (error) => {
        this.showLoader = false;
      }
    );
  }

  getLocalData() {
    var consumerDataLocal = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    this.consumerData = JSON.parse(consumerDataLocal);
    console.log("this.consumerData ", this.consumerData);
  }

  getRateRange() {
    this.masterDataService.getCurrentRateListCard().subscribe((resp) => {
      this.singleRateResItem = JSON.parse(JSON.stringify(resp.body));
      this.currencyItems = this.singleRateResItem[0].rates;
      console.log("SINGLE RATE >> ", this.currencyItems);
      if (this.ssoResponseData) {
        if (this.currencyAmount) {
        }
      }
    });
  }
  getCurrencies() {
    this.reqGetCurrencyMaster.cartType = "CASH_PURCHASE";
    // this.reqGetCurrencyMaster.cartType = PurposeList.purpose[0].remittanceType;
    this.reqGetCurrencyMaster.countryCode = "US";
    this.reqGetCurrencyMaster.issuer = "";
    this.reqGetCurrencyMaster.partnerId = Constants.partnerId;
    this.reqGetCurrencyMaster.product = Constants.productsEnum[1];

    this.masterDataService
      .getCurrenciesList(this.reqGetCurrencyMaster)
      .subscribe((result) => {
        this.currencyItems = result.body;
        // this.removeCurrency('SEK');
        this.removeCurrency("DKK");
        this.removeCurrency("INR");
        this.removeCurrency("NOK");
      });
  }
  removeCurrency(doc) {
    this.currencyItems.forEach((item, index) => {
      if (item["currencyCode"] === doc) this.currencyItems.splice(index, 1);
    });
  }

  convertAmount() {
    if (this.currencyAmount) {
      var sellType;
      if (this.activeSellCurrencyNotes) {
        sellType = Constants.sellTypes[1];
      } else {
        sellType = Constants.sellTypes[0];
      }
      this.masterDataService
        .rateCalculatorConvertor(
          this.currencyAmount,
          this.currencySelected,
          sellType,
          Constants.productsEnum[1],
          "CASH"
        )
        .subscribe(
          (resp) => {
            let rateResponse = resp.body;
            this.rateCalculatorResponse = rateResponse["cashRateResponse"];
            var cardRateCalculatorObject = {
              requiredCurrencyCodeAmount: this.currencyAmount,
              requiredCurrencyCode: this.currencySelected,
            };
            if (this.activeBuyCurrenyNotes) {
              this.inrAmount = this.rateCalculatorResponse['inrAmountWithCharges'];

            } else {
                            this.inrAmount = this.rateCalculatorResponse['inrAmount'];

            }
            this.showErrorModal = false;
            localStorage.setItem(
              ConstantsKey.SSO_RESP,
              JSON.stringify(cardRateCalculatorObject)
            );
            console.log(
              "this.rateCalculatorResponse_+_+",
              this.rateCalculatorResponse
            );
            this.callQuotation();
          },
          (err) => {
            console.log(err);
            this.showErrorModal = true;
            this.cashLimitErrorMsg = err.error.message;
            Swal.fire({
              title: "Dear Customer",
              html: this.cashLimitErrorMsg,
              imageUrl: "assets/images/icons/info_icon.png",
              imageWidth: 80,
              imageHeight: 80,
              focusConfirm: false,
              confirmButtonColor: "#080808",
            });

            //this.modalReference = this.modalService.open(this.AmountLimitModal, { centered: true, size: 'sm' });
          }
        );
    } else {
      this.rateCalculatorResponse = {};
      this.rateCalculatorResponse.inrAmount = "Amount";
    }
  }

  callThreeWayCalculator() {

      var sellType;
      if (this.activeSellCurrencyNotes) {
        sellType = Constants.sellTypes[1];
      } else {
        sellType = Constants.sellTypes[0];
      }

    let currenctBranchName = "";
    let currenctBranchId = "";       
  
      if(!this.selectedBranch) {
        currenctBranchName = "Mumbai";
        currenctBranchId = "b-wsfl15";        
      } else {
        currenctBranchName = this.selectedBranch?.branchName;
        currenctBranchId = this.selectedBranch?.branchId;
      }

      this.masterDataService
        .b2cCalculator(
          Constants.productsEnum[1],
          sellType,
          'CASH',
          this.currencySelected,
          this.currencyAmount,
           this.currencySelected,
         this.currencyAmount,
          this.inrAmount,
          'required',
          currenctBranchName,
          currenctBranchId,
          ""
        )
        .subscribe( (resp) => {
              let rateResponse = resp.body;
          this.rateCalculatorResponse = rateResponse;
            this.inrAmount = rateResponse['finalInrAmount'];
    
              this.showErrorModal = false;
              //localStorage.setItem(ConstantsKey.SSO_RESP, JSON.stringify(cardRateCalculatorObject));
              console.log(
                "this.rateCalculatorResponse_+_+",
                this.rateCalculatorResponse
              );
              //this.createQuotation();
              this.callQuotation();
            },
            (err) => {
              console.log(err);
              if (
                err.error.message ==
                "Buying more than 25000$ or equivalent is not allowed for consumer."
              ) {
                this.showErrorModal = true;
                this.cashLimitErrorMsg = err.error.message;
                Swal.fire({
                  title: "Dear Customer",
                  html: this.cashLimitErrorMsg,
                  imageUrl: "assets/images/icons/info_icon.png",
                  imageWidth: 80,
                  imageHeight: 80,
                  focusConfirm: false,
                  confirmButtonColor: "#080808",
                });
                //this.modalReference = this.modalService.open(this.AmountLimitModal, { centered: true, size: 'sm' });
              }
            });
      
     
      
    }

  showHidePricingRange(showPricing: boolean) {
    this.showPricing = showPricing;
  }

  getCurrencyFields() {
   // this.convertAmount();
    this.callThreeWayCalculator();
  }

  callQuotation() {
    this.showLoader = true;
    if (this.currencySelected) {
      if (this.currencyAmount && this.currencyAmount >= 0) {
        let orderRequestList = [];
        let singleRequestCurrency: CartItemCreateRequestList =
          new CartItemCreateRequestList();
        singleRequestCurrency.currencyAmount = this.currencyAmount;
        singleRequestCurrency.currencyCode = this.currencySelected;
        singleRequestCurrency.product = Constants.productsEnum[1];
        // singleRequestCurrency.bidRate = 92.80;

        singleRequestCurrency.purpose = "PRIVATE_VISIT";
        orderRequestList.push(singleRequestCurrency);
        if (this.activeBuyCurrenyNotes) {
          this.quotationRequest.sellType = Constants.sellTypes[0];
        } else if (this.activeSellCurrencyNotes) {
          this.quotationRequest.sellType = Constants.sellTypes[1];
        } else {
          this.quotationRequest.sellType = Constants.sellTypes[0];
        }
        this.quotationRequest.partnerId = Constants.partnerId;
        this.quotationRequest.nostroChargeType = "REMITTER";
        this.quotationRequest.quotationCurrencies = orderRequestList;

        this.quotationRequest.pan = this.consumerPanSelf;
        this.quotationRequest.tcsPaymentSource = this.tcsPaymentSource;

        if (this.quotationResponse) {
          this.quotationRequest.quotationSnapshotId =
            this.quotationResponse.quotationSnapshotId;
        }

        this.cardService.getQuotationEncrypted(this.quotationRequest).subscribe(
          (respQuote) => {
            this.showLoader = false;

            this.quotationResponse = respQuote.body;
            this.quotationCurrencyResponsesList =
              this.quotationResponse["quotationCurrencyResponses"];
            this.quotationSnapshotId =
              this.quotationResponse.quotationSnapshotId;
          },
          (error) => {
            this.showLoader = false;
            this.showPricing = false;
            if (error.status == 200) {
              this.cashLimitError = false;
              this.showErrorModal = false;

              this.quotationResponse = JSON.parse(
                this.cryptoUtils.resDecrypt(error.error.text)
              );
              console.log("quotationResponse>>> ", this.quotationResponse);

              this.quotationCurrencyResponsesList =
                this.quotationResponse["quotationCurrencyResponses"];
              this.quotationSnapshotId =
                this.quotationResponse.quotationSnapshotId;
            } else {
              this.cashLimitError = true;
              this.showErrorModal = true;

              this.cashLimitErrorMsg = error.error.message;
              console.log("cashLimitErrorMsg>>> ", error.error.message);
              console.log("cashLimitErrorStatus>>> ", error.status);

              //this.toast.error(error.error.message);
              if (this.activeBuyCurrenyNotes || this.activeSellCurrencyNotes) {
                if (
                  !this.cashLimitErrorMsg.includes("encashment of coins") &&
                  !this.cashLimitErrorMsg.includes(
                    "denomination in multiples of 10"
                  )
                ) {
                  Swal.fire({
                    title: "Dear Customer",
                    text: error.error.message,
                    imageUrl: "assets/images/icons/info_icon.png",
                    imageWidth: 80,
                    imageHeight: 80,
                    focusConfirm: false,
                    confirmButtonColor: "#080808",
                  });
                }
              }
            }
          }
        );

        this.showPricing = true;
      } else {
        this.showLoader = false;
        //this.toast.error("Please fill in the currency amount.");
      }
    } else {
      this.showLoader = false;
      this.toast.error("Please fill in the currency");
    }
  }
  // proceedToBuy(){
  //   if (this.currencyAmount) {
  //     if (this.activeBuyCurrenyNotes || this.activeSellCurrencyNotes) {

  //               if(sessionStorage.getItem("showVCIPModalForCashFlow") && this.activeBuyCurrenyNotes){
  //                     if(sessionStorage.getItem("showVCIPModalForCashFlow")=="openModalForVCIPNewUser"){
  //                       this.openModalForVCIPNewUser();
  //                     }else{
  //                       this.openModalForVCIP();
  //                     }
  //                 }else{
  //                     this.proceedToBuy();
  //                 }
  //       }else {
  //         this.toast.error('Please Select your Action as Buy or Sell Currency Notes');
  //         }
  //   }else {
  //     this.toast.error('Please enter amount');
  //   }
  // }

  async proceedToBuy() {
    if (this.activeSellCurrencyNotes && !(this.currencyAmount % 10 == 0)) {
      //Swal.fire("Dear Customer", "kindly be informed that we do not accept the encashment of coins. Please deposit Currency Notes only.<br> Thank you for your cooperation", "info");
      Swal.fire({
        title: "Dear Customer",
        html: "kindly be informed that we do not accept the encashment of coins. Please deposit Currency Notes only.<br> Thank you for your cooperation",
        imageUrl: "assets/images/icons/info_icon.png",
        imageWidth: 80,
        imageHeight: 80,
        focusConfirm: false,
        confirmButtonColor: "#080808",
      });
    }
    this.quotationRequestModel = new QuotationRequestModel();
    this.quotationRequestModel.sellType = Constants.sellTypes[0];
    this.quotationRequestModel.partnerId = Constants.partnerId;
    let quotationCurrencies = new QuotationCurrenciesRequestModel();
    quotationCurrencies.currencyAmount = this.currencyAmount;
    quotationCurrencies.currencyCode = this.currencySelected;
    quotationCurrencies.product = Constants.productsEnum[1];
    quotationCurrencies.purpose = "PRIVATE_VISIT";
    this.cartCurrenciesList.push(quotationCurrencies);
    localStorage.setItem(
      "cartCurrenciesList",
      JSON.stringify(this.cartCurrenciesList)
    );
    if (!this.showErrorModal) {

      if(this.selectedBranch?.branchId) {
        sessionStorage.setItem(ConstantsKey.SELECTED_CURRENCY_BRANCH, this.selectedBranch?.branchId);
      } else {
        sessionStorage.setItem(ConstantsKey.SELECTED_CURRENCY_BRANCH, "b-wsfl15");        
      }


      if (this.activeBuyCurrenyNotes) {
        this.router.navigate(["/currency-notes-view-cart"]);
      } else {
        this.router.navigate(["/sell-currency-notes"]);
      }
    } else {
      // Swal.fire("Dear Customer", this.cashLimitErrorMsg, "info");
      if (this.activeBuyCurrenyNotes) {
        Swal.fire({
          title: "Dear Customer",
          html: this.cashLimitErrorMsg,
          imageUrl: "assets/images/icons/info_icon.png",
          imageWidth: 80,
          imageHeight: 80,
          focusConfirm: false,
          confirmButtonColor: "#080808",
        });
      }
    }
  }

  alphaNumberOnly(e) {
    // Accept only alpha numerics, not special characters
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  showBuyCurrencyNotes(data) {
    if (data == "BUY") {
      this.activeBuyCurrenyNotes = true;
      this.activeSellCurrencyNotes = false;
      // this.convertAmount();
      this.callThreeWayCalculator();
       this.currencyText = 'You Get';
      this.inrText = "You Pay";

      //this.openModalCurrencyBuy();
    } else {
      this.currencyText = 'You Bring';
            this.inrText = "You Get";
      this.activeSellCurrencyNotes = true;
      this.activeBuyCurrenyNotes = false;
      //this.callQuotation();
      // this.convertAmount();
            this.callThreeWayCalculator();

    }
  }

  checkVCIPComplete() {
    if (
      !this.isVcipComplete &&
      !this.proceedWithoutVCIPCompletion &&
      !this.cardLinkedAlready
    ) {
      this.openModalForVCIP();
    }
  }

  openModalForVCIP() {
    this.modalReference = this.modalService.open(this.vcipCompleteOrNotModal, {
      size: "xl",
      centered: true,
    });
  }
  openModalForVCIPNewUser() {
    this.modalReference = this.modalService.open(this.vcipModalNewUser, {
      centered: true,
    });
  }
  openModalCurrencyBuy() {
    this.modalReference = this.modalService.open(this.currenyBuyModal, {
      size: "lg",
      centered: true,
    });
  }

  initiateVcip() {
    this.modalReference.close();
    this.updateProfileService.getVCIPRedirectionURL().subscribe(
      (resp) => {
        this.showLoader = false;
        var vcipResponse = JSON.parse(JSON.stringify(resp.body));
        let vcipUrl = vcipResponse.mobileAutologinUrl;
        window.open(vcipUrl, "_blank");
      },
      (error) => {
        this.showLoader = false;
        this.toast.error(JSON.stringify(error.error.message));
      }
    );
  }

  proceedWithourVCIP() {
    this.modalReference.close();
    this.isVCIPNow = false;
    if (this.isOrderWithoutVcipComplete) {
      sessionStorage.setItem("PROCEED-WITHOUT-VCIP", "true");
      sessionStorage.removeItem("showVCIPModalForCashFlow");
    } else {
      if (this.isPANAvailable) {
        sessionStorage.setItem("PROCEED-WITHOUT-VCIP", "true");
        sessionStorage.removeItem("showVCIPModalForCashFlow");
      } else {
        this.openModalForPANNo();
      }
    }
  }

  openModalForPANNo() {
    this.modalReference.close();
    this.modalReference = this.modalService.open(this.PANDetailModal, {
      centered: true,
      size: "sm",
    });
  }
  validatePanDetails() {
    if (!(this.updateProfileModel.pan != null)) {
      this.toast.error("Please enter your PAN");
      return false;
    }
    if (!this.validatePANNo(this.updateProfileModel.pan)) {
      this.toast.error("Please enter valid PAN");
      return false;
    }
    if (!(this.updateProfileModel.name != null)) {
      this.toast.error("Please enter name as per PAN");
      return false;
    }
    if (!this.isPANCBChecked) {
      this.toast.error("Please check the declaration of PAN");
      return false;
    }
    if (!(this.updateProfileModel.dob != null)) {
      this.toast.error("Please select your Date of Birth ");
      return false;
    }

    return true;
  }
  openErrorModal() {
    this.modalReference = this.modalService.open(this.errorModal, {
      centered: true,
      size: "sm",
    });
  }
  validatePanAPI() {
    if (this.validatePanDetails()) {
      this.showLoader = true;
      let dateofBirth = DateUtils.getNgbDateStructToDatev2(
        this.updateProfileModel.dob
      );

      this.updateProfileService
        .validatePAN(
          this.updateProfileModel.pan,
          this.updateProfileModel.name,
          dateofBirth
        )
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              // && panResponse.fullName != "" && panResponse.dob != ""
              this.updatePAN();
            } else if (panResponse.panStatus != "E") {
              this.panVerificationErrMsg = "Please enter valid PAN";
              this.openErrorModal();
            } /* else if (panResponse.fullName == "") {
        this.panVerificationErrMsg = "Please enter Name as per PAN";
        this.openErrorModal();
      }
      else if (panResponse.dob == "") {
        this.panVerificationErrMsg = "Please enter valid Date of Birth";
        this.openErrorModal();
      } */
          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
    }
  }
  getPanName() {
    this.updateProfileModel.pan = this.updateProfileModel.pan.toUpperCase();
    if (
      this.updateProfileModel.pan &&
      this.updateProfileModel.pan.length == 10 &&
      this.validatePANNo(this.updateProfileModel.pan)
    ) {
      this.showLoader = true;
      this.updateProfileService
        .getPANName(this.updateProfileModel.pan)
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              if (
                panResponse.fullName &&
                panResponse.fullName != "null" &&
                panResponse.fullName != ""
              ) {
                this.updateProfileModel.name = panResponse.fullName;
              } else {
                this.updateProfileModel.name = "";
              }

              if (
                panResponse.dob &&
                panResponse.dob != "null" &&
                panResponse.dob != ""
              ) {
                this.updateProfileModel.dob =
                  DateUtils.ngbDateStructDateConverter(panResponse.dob);
              }
            } else if (
              panResponse.flatPan.status ==
              "Record Not Found in ITD Database/Invalid PAN"
            ) {
              this.updateProfileModel.name = "";
              this.updateProfileModel.dob = "";
              this.toast.error("Invalid Pan");
            } /* else {
          this.toast.error(panResponse.flatPan.status);
        } */
          },
          (error) => {
            this.showLoader = false;
            this.updateProfileModel.name = "";
            this.updateProfileModel.dob = "";
            this.toast.error(error.error.message);
          }
        );
    }
  }

  updatePAN() {
    this.showLoader = true;
    this.updateProfileModel.mobile = this.consumerData.mobile;
    this.updateProfileModel.email = this.consumerData.email;
    let dateofBirth = DateUtils.getNgbDateStructToDate(
      this.updateProfileModel.dob
    );
    this.updateProfileModel.dob = dateofBirth;

    this.updateProfileService
      .updateProfileDetails(this.paxId, this.updateProfileModel)
      .subscribe(
        async (resp) => {
          this.showLoader = false;
          console.log(resp.body);
          sessionStorage.setItem("PROCEED-WITHOUT-VCIP", "true");
          this.modalReference.close();
          //this.proceedToViewCart();
        },
        (error) => {
          this.showLoader = false;
          if (error.status == 200) {
            sessionStorage.setItem("PROCEED-WITHOUT-VCIP", "true");
            this.showLoader = false;
            this.modalReference.close();
            this.proceedToBuy();
            if (this.isVCIPNow) {
              this.initiateVcip();
            }
            //this.proceedToViewCart();
          } else {
            this.toast.error("Something went wrong ! Please try again !");
          }
        }
      );
  }

  proceedToViewCart() {
    if (this.showBuyForexForm) {
      if (this.currencyAmount) {
        this.quotationRequestModel = new QuotationRequestModel();
        this.quotationRequestModel.sellType = Constants.sellTypes[0];
        this.quotationRequestModel.partnerId = Constants.partnerId;

        let quotationCurrencies = new QuotationCurrenciesRequestModel();
        quotationCurrencies.bidRate = +JSON.stringify(
          this.currencySelectedObj.minSalePriceInINR
        );
        quotationCurrencies.currencyAmount = this.currencyAmount;
        quotationCurrencies.currencyCode = this.currencySelected;
        quotationCurrencies.product = Constants.productsEnum[1];
        quotationCurrencies.purpose = "PRIVATE_VISIT";

        this.cartCurrenciesList.push(quotationCurrencies);
        localStorage.setItem(
          "cartCurrenciesList",
          JSON.stringify(this.cartCurrenciesList)
        );
        sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, "true");
        sessionStorage.setItem(ConstantsKey.IS_FROM_REMITTANCE_FLOW, "false");
        sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, "false");
        this.router.navigate(["/view-cart"]);
      } else {
        this.toast.error("Please enter amount");
      }
    } else {
      this.toast.error("Please select Buy New Card Section !");
    }
  }

  VCIPNow() {
    this.isVCIPNow = true;
    this.openModalForPANNo();
  }

  validatePANNo(panNo) {
    const regex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
    if (!regex.test(panNo)) {
      return false;
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.currencyInputsubscription.unsubscribe();
  }
  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }  
  
  getNearByBranchLocation() {
    this.cardService.getNearByBranch(0.0, 0.0).subscribe(respBranchList => {
      this.branchAddressList = JSON.parse(JSON.stringify(respBranchList.body));
    });
  }

  changeBranch(branch) {
    this.selectedBranch = branch;
    this.callThreeWayCalculator();
  }
}
